<template>
  <div class="p-checkboxes">
    <PCheckBox
      v-for="option in booleanOptions"
      :key="option.id"
      :value="option.checked"
      :label="option.label"
      :disabled="disabled"
      @value-changed="emitValueChanged(option.id)"
    />
  </div>
</template>

<script setup lang="ts">
import PCheckBox from "./PCheckBox.vue";
import type { BooleanOption } from "@/models/questions/booleanOption";

withDefaults(
  defineProps<{
    booleanOptions: BooleanOption[];
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  }
);

const emit = defineEmits<{
  (e: "value-selected", newValue: string): void;
}>();

function emitValueChanged(boolValue: string): void {
  emit("value-selected", boolValue);
}
</script>

<style scoped lang="scss">
.p-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
